/* SC: Subscription promo. Head rises from the corner, bubble grows out of his mouth, he talks while the words land. GSAP. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function talk(head, ms) {
    // cut-paper mouth: closed, half, wide, half... like the FAQ head
    const seq = ['', 'm2', 'm3', 'm3', 'm2', '', 'm2', 'm3', 'm2'];
    let i = 0; const step = 90; const n = Math.max(1, Math.round(ms / step));
    const id = setInterval(() => {
      head.classList.remove('m2', 'm3');
      const c = seq[i % seq.length]; if (c) head.classList.add(c);
      if (++i >= n) { clearInterval(id); head.classList.remove('m2', 'm3'); }
    }, step);
  }
  // Tail: a wedge from the bubble's bottom edge to the left corner of his mouth, in head-box pixels.
  const MOUTH = [0.417, 0.389];
  function drawTail(root) {
    const head = root.querySelector('[data-sc-head]');
    const bub = root.querySelector('.sc-sub__bubble');
    const svg = root.querySelector('.sc-sub__tail');
    if (!head || !bub || !svg) return;
    const W = head.offsetWidth, H = head.offsetHeight;
    const tx = W * MOUTH[0], ty = H * MOUTH[1];
    const br = bub.offsetLeft + bub.offsetWidth, bb = bub.offsetTop + bub.offsetHeight;
    const poly = svg.querySelector('polygon'), line = svg.querySelector('polyline');
    if (ty - bb > tx - br) {
      // mouth is mostly below the bubble: tail drops from the bottom edge
      const x2 = Math.min(br - 30, tx), y = bb - 2.5;
      const base = Math.max(44, Math.min(bub.offsetWidth * .3, Math.hypot(tx - x2, ty - y) * .45));
      const x1 = x2 - base;
      poly.setAttribute('points', `${x1},${bb - 6} ${x2},${bb - 6} ${tx},${ty}`);
      line.setAttribute('points', `${x1},${y} ${tx},${ty} ${x2},${y}`);
    } else {
      // mouth is off to the side: tail leaves the right edge just above the corner
      const x = br - 2.5, y2 = bb - 30;
      const base = Math.max(44, Math.min(bub.offsetHeight * .42, Math.hypot(tx - x, ty - y2) * .4));
      const y1 = y2 - base;
      poly.setAttribute('points', `${br - 6},${y1} ${br - 6},${y2} ${tx},${ty}`);
      line.setAttribute('points', `${x},${y1} ${tx},${ty} ${x},${y2}`);
    }
    svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
  }
  function init() {
    document.querySelectorAll('[data-sc-sub]').forEach((root) => {
      drawTail(root);
      if ('ResizeObserver' in window) new ResizeObserver(() => drawTail(root)).observe(root);
      if (document.fonts) document.fonts.ready.then(() => drawTail(root));
      const gsap = window.gsap;
      const head = root.querySelector('[data-sc-head]');
      const bubble = root.querySelector('[data-sc-bubble]');
      const p = bubble && bubble.querySelector('p');
      if (reduce || !gsap || !('IntersectionObserver' in window) || !head || !bubble) return;
      const words = p.textContent.trim().split(/\s+/);
      p.innerHTML = words.map((w) => `<span class="sc-sub__w">${w}</span>`).join(' ');
      const ws = p.querySelectorAll('.sc-sub__w');
      gsap.set(head, { yPercent: 70, rotation: 9, transformOrigin: '50% 100%' });
      gsap.set(bubble, { scale: .2, opacity: 0, rotation: 6 });
      gsap.set(ws, { opacity: 0, y: 10 });
      const tl = gsap.timeline({ paused: true });
      tl.to(head, { yPercent: 0, rotation: 0, duration: 1.1, ease: 'expo.out' }, 0)
        .to(bubble, { scale: 1, opacity: 1, rotation: 0, duration: .6, ease: 'expo.out' }, .55)
        .call(() => talk(head, 1700), null, .62)
        .to(ws, { opacity: 1, y: 0, duration: .35, ease: 'power3.out', stagger: .14 }, .7);
      const io = new IntersectionObserver((es) => {
        if (es.some((e) => e.isIntersecting)) { io.disconnect(); tl.play(); }
      }, { threshold: .35 });
      io.observe(root);
      // he says it again if you hang around
      root.addEventListener('pointerenter', () => { if (tl.progress() === 1) talk(head, 1300); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
